import FormConfig from "./formConfig.js";
import { fun_PostAction } from "@/api/index";
import { deepCopy } from "@/utils/validate.js";
// 引入招标人选择页面
import CorpBasicinfoChoose from "../../components/corpBasicinfoChoose/index.vue";
// 引入附件上传页面
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {    
        tenderUnionId: null, // 联合体招标协议主键
        tenderUnionDescription: null, // 备注
        unionBasicInfoId: null, // 招标人编号
        unionCorpName: null, // 招标人名称
        isUnionTender: null, // 是否联合体
      },
      // 表单错误
      errRules: {
        unionCorpName: null, // 招标人名称
        tenderUnionDescription: null, // 备注
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 操作类型
      controllerFlg: null, 
      // 主键
      id: null, 
      // 修改的招标人编号
      updBasicInfoId: null, 
      /*****************************联合招标单位信息****************************/
      detailLoading: false,  // 列表loading状态
      // 查询表单字段
      detailForm: {
        basicInfoId: null, // 招标单位编号
        corpName: null, // 招标单位名称
      },
      // 表格基础数据
      detailTableColumns: [
        {
          label: "招标单位名称",
          prop: "corpName",
        },
        {
          label: "操作",
          slotName: "operation",
        },
      ],
      // 表格数据
      detailTableData: [],
    };
  },
  // 接收来自父组件的数据
  props: {
    // 用于判断是否为子组件
    isComponent: {
      type: Boolean,
      default: false
    },
  },
  // 注册组件
  components: {
    CorpBasicinfoChoose, // 招标人
    TenderPictureinfor, // 附件上传一览
  },
  // 模板编译完成
  mounted() {
    
  },
  // 自定义方法
  methods: {
    /**
    * details页面初始化后开始加载各子页面方法
    */
    fun_Open() {
      // 如果是详情
      if (this.controllerFlg === 'detail') {
        // 遍历
        this.formConfigList.map(item => {
          // 如果表头是
          if (item.title == '联合招标其他单位信息'){
            // 重新定义表单
            item.formConfigList = [
              {
                label: "",
                type: "slot",
                slotName: "detailList",
                value: "detailList",
                class: "formList"
              },
            ];
          }
          // 遍历
          item.formConfigList.map(e => {
            // 禁止输入
            e.disabled = true;
          })
        });
        // 联合招标单位信息重新赋值
        this.detailTableColumns = [
          {
            label: "招标单位名称",
            prop: "corpName",
          }, 
        ];
      }
      // 获取联合体招标协议详情一览
      this.fun_TenderUnionDetailList();
    },  
    /**
     * 联合体招标协议详情一览
     */
    fun_TenderUnionDetailList(){
      // 联合体协议编号不为空
      if (this.form.tenderUnionId != '' && this.form.tenderUnionId != null){
        // 请求，获取结果集
        fun_PostAction("/tenderUnion/tenderUnionDetailList", {
          unionAgreementId: this.form.tenderUnionId
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 判断请求是否成功
          if (result) {
            // 回显table
            this.detailTableData = data;
          }
        });
      }
    },
    /**
     * 招标单位选择
     * @param e
     */
    fun_GetTenderCorp(e){
      // 打开弹框
      if (e == "open") {
        // 打开弹窗
        this.$refs.corpBasicinfoChoose.dialogVisible = true;
        // 请求接口
        this.$refs.corpBasicinfoChoose.fun_GetOpen();
        // 设置表单样式
        this.$refs.corpBasicinfoChoose.fun_TableColumns();
      }
      // 清空招标人信息
      else if(e == "claer"){
        // 招标人主键清空
        this.form.unionBasicInfoId = "";
        // 招标人名称清空
        this.form.unionCorpName = "";
      }
      // 添加招标人信息
      else if(e == "add"){
        // 如果招标人是否联合体选择否或者空
        if(this.form.isUnionTender != "1"){
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("招标单位是否联合体未选择是，请检查后再添加！");
          return false;
        }  
        // 未选择好表单位时
        if(this.form.unionBasicInfoId == null || this.form.unionBasicInfoId == ''){
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("招标单位未选择，请检查后再添加！");
          return false;
        }
        // 表单
        let form = {};
        // 设置招标人编号
        form.basicInfoId = this.form.unionBasicInfoId;
        // 设置招标人名称
        form.corpName = this.form.unionCorpName;
        // 修改的招标人编号不为空时
        if(this.updBasicInfoId != null && this.updBasicInfoId != ""){
          // 设置下标
          let index = 0;
          // 遍历表单
          this.detailTableData.map((e, i) => {
            // 如果需要修改的招标人编号与当前招标人编号相同时
            if (e.basicInfoId === this.updBasicInfoId) {
              index = i;
            }
          });
          // 将改对象直接从数组中替换
          this.detailTableData.splice(index, 1, deepCopy(form));
        }
        // 为空时
        else{
          // 设置数量
          let num = 0;
          // 遍历表单
          this.detailTableData.map((e, i) => {
            // 如果需要修改的招标人编号与当前招标人编号相同时
            if (e.basicInfoId === form.basicInfoId) {
              num++;
            }
          });
          // 存在重复数据时
          if(num > 0){
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("招标单位选择重复，请修改后再保存！");
            return false;
          }
          // 添加表单
          this.detailTableData = [...this.detailTableData, { ...form }];
        }
        // 招标人主键清空
        this.form.unionBasicInfoId = "";
        // 招标人名称清空
        this.form.unionCorpName = "";
        // 修改的招标人编号清空
        this.updBasicInfoId = "";
      }
    },
    /**
     * 设置招标单位
     */
    fun_SetTenderCorp(corpId, corpName){
      // 招标人主键赋值
      this.$set(this.form, "unionBasicInfoId", corpId);
      // 招标人名称赋值
      this.$set(this.form, "unionCorpName", corpName);
    },
    /**
     * 修改联合招标单位信息
     */
    fun_UpdTenderUnionDetail(e){
      // 修改的招标人编号
      this.updBasicInfoId = e.basicInfoId;
      // 招标人主键赋值
      this.$set(this.form, "unionBasicInfoId", e.basicInfoId);
      // 招标人名称赋值
      this.$set(this.form, "unionCorpName", e.corpName);
    },
    /**
     * 删除联合招标单位信息
     */
    fun_DelTenderUnionDetail(e){
      // 询问框
      this.$confirm('确认删除该招标单位信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 设置下标
        let index = 0;
        // 遍历表单
        this.detailTableData.map((j, i) => {
          // 如果需要修改的招标人编号与当前招标人编号相同时
          if (j.basicInfoId === e.basicInfoId) {
            index = i;
          }
        });
        // 将改对象直接从数组中替换
        this.detailTableData.splice(index, 1);
      });
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor() {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
  }
};
